var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useConfig } from '../../../context/ConfigContext';
import { useEventApi } from '../../../hooks/useEvent/useEventApi';
import { SpaceBookingWrapper } from '../../../SpaceBooking/SpaceBooking';
import { useEventDetailContext } from '../../context/EventDetailContextProvider';
import { ConfirmRoomChangeModal } from './ConfirmRoomChangeModal';
import { isMicrosoftManagedRemoteType } from './roomChangeNotify';
/**
 * Space picker for the details panel's "change room" action. Thin glue over
 * `SpaceBookingWrapper` (the composer-agnostic layer of the composer's
 * sider — availability, location/level selects, search): feeds it the
 * event's own times, hides EVERY space already on the event (moving the
 * organizer onto an existing invitee space is composer collision-rule
 * territory, not supported here), and funnels the chosen space through
 * ConfirmRoomChangeModal into `moveOrganizerSpace`.
 */
export var SpaceMovePicker = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose;
    var _d = useEventDetailContext(), event = _d.event, spaceData = _d.spaceData, parsedDateTime = _d.parsedDateTime, isRecurringEvent = _d.isRecurringEvent, moveOrganizerSpace = _d.moveOrganizerSpace, onError = _d.onError;
    var _e = useConfig(), accessToken = _e.accessToken, environmentUrls = _e.environmentUrls, tenantId = _e.tenantId, userContext = _e.userContext;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var fetchSpace = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).fetchSpace;
    var _f = __read(useState(null), 2), pendingTarget = _f[0], setPendingTarget = _f[1];
    var _g = __read(useState(false), 2), confirming = _g[0], setConfirming = _g[1];
    var isMicrosoftEvent = isMicrosoftManagedRemoteType(event === null || event === void 0 ? void 0 : event.remote_type);
    var spaces = useMemo(function () { return Array.from(spaceData.values()); }, [spaceData]);
    var organizerSpace = useMemo(function () { return spaces.find(function (space) { return space.isOrganizer; }); }, [spaces]);
    /**
     * Every space already on the event: hidden from the picker outright, and
     * passed as `spacesAdded` so the one-request-only-space rule still gates
     * request-only candidates.
     */
    var eventSpaceIds = useMemo(function () { return spaces.map(function (space) { return space.id.toString(); }); }, [spaces]);
    var handleSelectSpace = useCallback(function (spaceId) { return __awaiter(void 0, void 0, void 0, function () {
        var space;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchSpace({ spaceId: spaceId })];
                case 1:
                    space = _a.sent();
                    if (!space)
                        return [2 /*return*/];
                    setPendingTarget({ id: space.id, name: space.name });
                    return [2 /*return*/];
            }
        });
    }); }, [fetchSpace]);
    var handleConfirm = useCallback(function (notifyAttendees) { return __awaiter(void 0, void 0, void 0, function () {
        var moved;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingTarget)
                        return [2 /*return*/];
                    setConfirming(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, moveOrganizerSpace(pendingTarget, isMicrosoftEvent ? true : notifyAttendees)];
                case 2:
                    moved = _a.sent();
                    // On failure, keep the picker and confirm modal open (with the
                    // user's search/selection intact) so they can retry or pick
                    // another room. On success the whole panel is closing anyway.
                    if (moved) {
                        setPendingTarget(null);
                        onClose();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setConfirming(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [pendingTarget, moveOrganizerSpace, onClose, isMicrosoftEvent]);
    // Mount lazily so the sider's availability queries only run once the
    // action is used.
    if (!open && !pendingTarget)
        return null;
    if (!event || !parsedDateTime || !organizerSpace)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(SpaceBookingWrapper, { open: open, onClose: onClose, startTime: parsedDateTime.startTime, endTime: parsedDateTime.endTime, levelId: (_b = organizerSpace.level_id) === null || _b === void 0 ? void 0 : _b.toString(), locationId: (_c = organizerSpace.location_id) === null || _c === void 0 ? void 0 : _c.toString(), onAddSpace: handleSelectSpace, spacesAdded: eventSpaceIds, spaceIdsToHide: eventSpaceIds }), pendingTarget && (_jsx(ConfirmRoomChangeModal, { fromSpaceName: organizerSpace.name, toSpaceName: pendingTarget.name, isRecurring: isRecurringEvent, confirming: confirming, hideNotify: isMicrosoftEvent, onConfirm: handleConfirm, onCancel: function () { return setPendingTarget(null); } }))] }));
};
